import { t } from "i18next";
import React from "react";
import { useState, useEffect } from "react";
import Button from "../../UI/Buttons/Button";
import "./CancellationAndWinbacks.scss"
import { RSSFeed } from "./RSSFeed";
import usePageTitle from '../../../Hooks/usePageTitle';
import useBodyClass from '../../../Hooks/useBodyClass';
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { APIPost } from "../../API/APIRequest";
import ReactHtmlParser from 'html-react-parser';
import DOMPurify from "dompurify";



export function LossAversion(props) {
    const { t, i18n } = useTranslation();
    const {campaignData, handlePageChange, firstPageCancellation} = props;
    const [nextPage, setNextPage] = useState("");
    const { fid } = useParams();
    const lossAversionMessage = campaignData?.lossAversionMessage;

    const handleRedirection = () => {
        let returnUrl = sessionStorage.getItem("ReturnUrl");
        window.location.href = returnUrl;
    }

    const getNextPage = () =>{
        if(campaignData?.alternativeOffer?.showAlternativeOffer){
            return "RETENTION_OFFER";
        }else{
            if(campaignData?.showCancellationForm){
               return "CANCELLATION_REASONS";
            }else{
                return "ORDER_CANCELLATION";
            }
        }
    }

    useEffect(()=>{
        
        let page = getNextPage();
        setNextPage(page);

    },[campaignData])

    return (<>
       <div className="container-wrapper">
            <div className="container">
                <div className="item-container">
                     <div className="item-wrapper">
                        {ReactHtmlParser(DOMPurify.sanitize(lossAversionMessage?.message || ""))}
                     </div>
                </div>

              

                {lossAversionMessage?.displayRssLink ?

                   <>

                       <div className="item-container">
                           <div class="border-seperator"></div>
                       </div>
                       <div className="item-container">
                            <div className="item-wrapper">
                                <h3>{lossAversionMessage?.title}</h3>
                            </div>

                            <div className="item-wrapper">
                                <RSSFeed lossAversionMessage={lossAversionMessage} fid={fid} />
                            </div>
                       </div>

                       <div className="item-container">
                            <div class="border-seperator"></div>
                       </div>
                  </>
                    : 
                ""}
                
              
                <div className="item-container">
                    <div className="item-wrapper one-row">
                        <Button type="button" buttonSize="medium" btnType="ghost" onClick={()=>{handlePageChange(nextPage)}}>{t('lossaversion.cancelbuttonlabel')}</Button>
                        <Button type="button" buttonSize="medium" onClick={(e) => { handleRedirection(e);}}>{t('lossaversion.keepbuttonlabel')} </Button>
                    </div>
                </div>
            </div>
        </div>
     </>)

}



